import React from 'react';
import InputMask from 'react-input-mask';
import { connect } from 'react-redux';

import { answerQuestion } from '../../../../../_actions/questionnaire.actions';

const Date = ({ question, answers, dispatch }) => {
  const answer = answers.find((answer) => {
    return answer.linkId === question.linkId
  });

  return (
    <>
      <h6 className="card-title">{question.linkId}. {question.text || 'Enter your question.'}</h6>

      <InputMask
        onChange={(e) => { dispatch(answerQuestion(question, e.target.value)) }}
        defaultValue={answer ? answer.answer : ''}
        className="form-control"
        type="text"
        inputMode="numeric"
        mask="99/99/9999"
      />
    </>
  );
}

const mapStateToProps = state => {
  return {
    answers: state.questionnaire.answers
  }
}

export default connect(mapStateToProps)(Date);